import { useEffect } from 'react';
import { useMap } from 'react-map-gl/maplibre';
import { symbolPixels } from '../../lib/point-symbols';
import { symbolImageId } from '../../lib/layer-style';

const SHAPES = ['square', 'triangle'];

/**
 * Registers the SDF point-symbol images on the map (lib/point-symbols.js). Images are
 * dropped when the basemap style changes, so they are (re-)added on `styleimagemissing`
 * as well as once at mount. Renders nothing.
 */
export default function PointSymbolImages() {
  const { current } = useMap();
  useEffect(() => {
    const map = current?.getMap?.();
    if (!map) return undefined;
    const add = (shape) => {
      const id = symbolImageId(shape);
      try {
        if (!map.hasImage(id)) map.addImage(id, symbolPixels(shape), { sdf: true });
      } catch { /* style not ready: styleimagemissing retries */ }
    };
    const onMissing = (e) => {
      const shape = SHAPES.find((s) => symbolImageId(s) === e.id);
      if (shape) add(shape);
    };
    SHAPES.forEach(add);
    map.on('styleimagemissing', onMissing);
    return () => { map.off('styleimagemissing', onMissing); };
  }, [current]);
  return null;
}
